import React, { useState, useEffect, useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { IoIosCloseCircle } from "react-icons/io";
import { CSSTransition } from 'react-transition-group';

const defaultTimeout = 5000;

function ToastrItem(props) {

    const { message, onClose } = props;
    const { index, type, timeout } = message;
    const [ closed, setClosed ] = useState(false);

    /**
     * @name _handleClose
     * @desc Set closed.
     */
    const _handleClose = useCallback(() => {
        setClosed(true)
    }, [setClosed])

    // Set timer to close the toastr automatically
    useEffect(() => {
        const timer = setTimeout(() => {
            _handleClose();
        }, (timeout || defaultTimeout));
        return () => clearTimeout(timer);
    }, [index, _handleClose, timeout])

    return (
        <div>
            <CSSTransition
                in={!closed}
                timeout={100}
                classNames="FadeIn"
                unmountOnExit
                onExited={() => onClose(index)}
            >
                <div className={`ToastrItem ${type}`}>
                    <span className="closeIcon" onClick={_handleClose}><IoIosCloseCircle/></span>
                    <span className="title">{message.title}</span>
                    <span className="details">{message.details}</span>
                </div>
            </CSSTransition>
        </div>
    )
}

ToastrItem.propTypes = {
    message: PropTypes.object.isRequired,
    onClose: PropTypes.func
}

export default ToastrItem;